/**
 * Increment when spaces-nav layout migration logic changes so persisted configs without a matching version
 * re-run {@link migrateSpacesNavFromLayoutConfigs} using preserved `layoutConfigs`.
 */
export const SPACES_NAV_LAYOUT_MIGRATION_VERSION = 1;

/** Re-apply from legacy `layoutConfigs` when stored version is missing or below the current migration version. */
export function shouldRunSpacesNavLayoutMigration(config: {
  spacesConfigs?: { spacesNavLayoutMigrationVersion?: number };
}): boolean {
  const v = config.spacesConfigs?.spacesNavLayoutMigrationVersion;
  return v == null || v < SPACES_NAV_LAYOUT_MIGRATION_VERSION;
}
